import React from 'react';
import { useNavigate } from 'react-router-dom';

// Technical Operations landing page: two sub-apps as full, professional cards,
// styled to match the EOMP light theme (CSS variables, blue brand).
const BRAND = '#2563EB';

export default function TechOpsHub() {
  const navigate = useNavigate();
  const cards = [
    {
      key: 'change',
      name: 'Change Requests & Incidents',
      desc: 'Raise change requests with dual-signature approvals, log incident reports, track maintenance windows, and export records.',
      tags: ['Change requests', 'Incidents', 'Approvals'],
      accent: BRAND,
      path: '/techops/change',
      letter: 'C',
    },
    {
      key: 'noc',
      name: 'NOC Operations',
      desc: 'Network Operations Center — issue tickets, site visits, shift performance reports, maintenance requests, live monitoring and a dashboard.',
      tags: ['Tickets', 'Monitoring', 'Shift reports'],
      accent: '#0D9488',
      path: '/techops/noc',
      letter: 'N',
    },
  ];

  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)', color: 'var(--text)' }}>
      {/* Header bar */}
      <div style={{ borderBottom: '1px solid var(--border)', background: 'var(--surface)' }}>
        <div style={{ maxWidth: 1180, margin: '0 auto', padding: '14px 28px', display: 'flex', alignItems: 'center', gap: 14 }}>
          <div style={{ width: 38, height: 38, borderRadius: 10, background: BRAND, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 800, fontSize: 17 }}>T</div>
          <div style={{ flex: 1 }}>
            <div style={{ fontSize: 17, fontWeight: 800, lineHeight: 1.1 }}>Technical Operations</div>
            <div style={{ fontSize: 12, color: 'var(--muted)' }}>Choose an application</div>
          </div>
          <button onClick={() => navigate('/hub')}
            style={{ background: 'none', border: '1px solid var(--border)', borderRadius: 8, padding: '8px 14px', cursor: 'pointer', fontSize: 13, color: 'var(--text)', fontWeight: 600 }}>
            ← App Hub
          </button>
        </div>
      </div>

      {/* Cards */}
      <div style={{ maxWidth: 1180, margin: '0 auto', padding: '32px 28px' }}>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(340px, 1fr))', gap: 22 }}>
          {cards.map(c => (
            <button key={c.key} onClick={() => navigate(c.path)}
              style={{ textAlign: 'left', background: 'var(--surface)', border: '1px solid var(--border)', borderRadius: 16, padding: 26, cursor: 'pointer',
                transition: 'box-shadow .16s, transform .16s, border-color .16s', boxShadow: '0 1px 2px rgba(16,24,38,0.04)', display: 'flex', flexDirection: 'column', minHeight: 230 }}
              onMouseEnter={e => { e.currentTarget.style.boxShadow = '0 10px 30px rgba(16,24,38,0.12)'; e.currentTarget.style.transform = 'translateY(-3px)'; e.currentTarget.style.borderColor = c.accent; }}
              onMouseLeave={e => { e.currentTarget.style.boxShadow = '0 1px 2px rgba(16,24,38,0.04)'; e.currentTarget.style.transform = 'none'; e.currentTarget.style.borderColor = 'var(--border)'; }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 16 }}>
                <div style={{ width: 54, height: 54, borderRadius: 13, background: c.accent, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 800, fontSize: 24, flexShrink: 0 }}>{c.letter}</div>
                <div style={{ fontSize: 19, fontWeight: 800 }}>{c.name}</div>
              </div>
              <div style={{ fontSize: 13.5, color: 'var(--muted)', lineHeight: 1.6, flex: 1 }}>{c.desc}</div>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: 7, margin: '16px 0 4px' }}>
                {c.tags.map(tag => (
                  <span key={tag} style={{ fontSize: 11.5, fontWeight: 600, color: 'var(--muted)', background: 'var(--bg)', border: '1px solid var(--border)', borderRadius: 99, padding: '4px 11px' }}>{tag}</span>
                ))}
              </div>
              <div style={{ marginTop: 12, fontSize: 13.5, fontWeight: 700, color: c.accent, display: 'flex', alignItems: 'center', gap: 6 }}>
                Open
                <svg width="15" height="15" viewBox="0 0 16 16" fill="none"><path d="M3 8h9M9 4.5L12.5 8 9 11.5" stroke={c.accent} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" /></svg>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
